import { useTranslation } from 'react-i18next';

interface ReceiverAddressInputProps {
  value: string;
  readOnly: boolean;
  onChange: (value: string) => void;
}

export function ReceiverAddressInput({
  value,
  readOnly,
  onChange,
}: ReceiverAddressInputProps) {
  const { t } = useTranslation();
  return (
    <div className="bg-foreground/2 ring-1 ring-foreground/5 backdrop-blur-md rounded-md p-3 space-y-2 mt-4">
      <h4 className="font-anta text-sm text-foreground/80">
        <Label htmlFor="receiver">{t('transfer.receiverAddress')}</Label>
      </h4>
      <Input
        type="text"
        value={value}
        readOnly={readOnly}
        className="shadow-none rounded-sm border-foreground/5"
        placeholder={t('transfer.enterReceiverAddress')}
        onChange={(e) => onChange(e.target.value.trim())}
      />
    </div>
  );
}


